export const NAME = 'opsReducer';
export const PAGE_TITLE_KEY = 'opsPage.table.title';

export const LS_KEY_OPS = 'ops';
